<template>
  <!--
      	作者：kmdshop
      	时间：2019-12-25
      	描述：插件中心-轮播图
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="轮播图管理" name="carousel">
                    <Carousel v-if="activeName=='carousel'"></Carousel>
                </el-tab-pane>
                <el-tab-pane label="轮播图分类管理" name="category">
                    <Category v-if="activeName=='category'"></Category>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Carousel from './carousel/Index.vue';
    import Category from './category/Index.vue';
    export default {
        components: {
          Carousel,
          Category,
        },
        data() {
            return {
                activeName: 'carousel',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/carousel/index.vue